<script lang="ts" setup>
import userStore from '@/store/UserStore.ts'
import bus from '@/helper/Bus.ts'
import { BusEvent } from '@/helper/Types.ts'
import ProjectController from '@/controllers/ProjectController.ts'
import { useRouter } from 'vue-router'

const router = useRouter()

function langClicked(lang: string): void {
  if (lang === userStore.currentLanguage) {
    return
  }
  userStore.currentLanguage = lang
  bus.$emit(BusEvent.LANGUAGE_CHANGED, lang)

  if (router.currentRoute.value.name === 'project' && !router.currentRoute.value.path.includes('/new')) {
    ProjectController.loadProject()
  }
}
</script>

<template>
  <div v-if="userStore.availableLanguages.length > 1" class="lang-switcher">
    <ul>
      <li v-for="(lang, i) in userStore.availableLanguages" :key="i">
        <span v-if="i > 0">|</span>
        <a :class="{ 'is--active': userStore.currentLanguage === lang }" href="#" @click.prevent="langClicked(lang)">
          {{ lang }}
        </a>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

ul {
  display: flex;
}

li {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;

  @include media('<desktop') {
    font-size: rem-calc(16);
  }

  @include themify($themes) {
    color: themed('primaryColorDark');
  }

  menu & {
    @include themify($themes) {
      color: $borderColor;
    }
  }

  span {
    margin: 0 rem-calc(8);
  }
}

a {
  text-transform: uppercase;

  @include themify($themes) {
    color: themed('primaryColorDark');
    text-decoration: none;
  }

  &.is--active {
    color: white;
    text-decoration: underline;
  }

  menu & {
    @include themify($themes) {
      color: $borderColor;
      text-decoration: none;
    }

    &.is--active {
      @include themify($themes) {
        color: themed('primaryColor');
        text-decoration: underline;
      }
    }
  }
}
</style>
